import { render, staticRenderFns } from "./titleBack.vue?vue&type=template&id=3090e7bc&scoped=true&"
import script from "./titleBack.vue?vue&type=script&lang=ts&"
export * from "./titleBack.vue?vue&type=script&lang=ts&"
import style0 from "./titleBack.vue?vue&type=style&index=0&id=3090e7bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3090e7bc",
  null
  
)

export default component.exports